
import _ from "lodash"
import { Id, ListItem } from "../../types"

// export default (listItems:ListItem[],selectedIds:Array<Id>)=>{
//   if(!selectedIds || !selectedIds?.length || selectedIds[0] === ""){
//     return []
//   }
//     return _.chain(listItems)
//     .keyBy('id')
//     .at(selectedIds)
//     .value().map(i => i.name)
//   }


  export default (listItems: ListItem[], selectedIds: Array<Id>) => {
    if (!selectedIds || !selectedIds.length || selectedIds[0] === "") {
      return [];
    }
  
    return _.chain(listItems)
      .keyBy('id')
      .at(selectedIds)
      .filter(i => !!(i && i.name))
            .map(i => i.name)
      .value();
  }